import React from 'react';
import Icon from './Icon';

export default function SettingsIcon(props) {
  return (
    <Icon viewBox="0 -960 960 960" {...props}>
      <path d="M234-275q51-39 114-61.5T480-359q69 0 132 22.5T726-275q35-41 54.5-93T800-479q0-133-93.5-226.5T480-799q-133 0-226.5 93.5T160-479q0 59 19.5 111t54.5 93Zm246-164q-59 0-99.5-40.5T340-579q0-59 40.5-99.5T480-719q59 0 99.5 40.5T620-579q0 59-40.5 99.5T480-439Zm0 360q-83 0-156-31.5T197-196q-54-54-85.5-127T80-479q0-83 31.5-156T197-762q54-54 127-85.5T480-879q83 0 156 31.5T763-762q54 54 85.5 127T880-479q0 83-31.5 156T763-196q-54 54-127 85.5T480-79Zm0-80q53 0 100-15.5t86-44.5q-39-29-86-44.5T480-279q-53 0-100 15.5T294-219q39 29 86 44.5T480-159Zm0-360q26 0 43-17t17-43q0-26-17-43t-43-17q-26 0-43 17t-17 43q0 26 17 43t43 17Zm0-60Zm0 360Z" />
    </Icon>
  );
}
